import { RewardsEntity } from "app/features/Categories/types/RewardsAccountType";
import { RewardsDetails } from "app/features/Rewards/types/RewardsDetails";
import { UserRewardsDetails } from "app/features/Rewards/types/UserRewardsDetails";

// Function to sort and filter the rewards based on user-specific details
const getSortedRewardsDetails = (
    rewardsDetailsInfo: RewardsDetails[], // List of all available rewards
    userRewardsDetailInfo: UserRewardsDetails[], // User-specific reward details
) => {
    if (!rewardsDetailsInfo || !userRewardsDetailInfo) return [];

    if (userRewardsDetailInfo?.length > 0 && rewardsDetailsInfo?.length > 0) {
        const updatedUserRewardsDetails = rewardsDetailsInfo.map((userRewardDetail) => {
           // Find the corresponding user reward by matching the rewardId
            const userReward = userRewardsDetailInfo?.find(
                (it) => it.id === userRewardDetail?.rewardId,
            );
            // If a user reward is found, merge the user reward data with the reward details
            return userReward
                ? {
                    ...userRewardDetail,
                    points: userReward?.criteria?.points?.toString(),
                    code: userReward?.code,
                    readyToUse: false,
                }
                : userRewardDetail;
        });

    //Filter rewards to only include those that are present in both the user and global rewards list
        const filteredRewards = updatedUserRewardsDetails.filter(
            (reward) => userRewardsDetailInfo.some((it) => it?.id === reward?.rewardId),
          );
          // Sort the filtered rewards in ascending order based on their points
        const sortedRewardsDetails = filteredRewards.sort(
            (first, second) => parseInt(first?.points, 10) - parseInt(second?.points, 10),
        );
        return sortedRewardsDetails;
    }

    return [];
};

export const isRewardExpired = (reward: RewardsDetails, pickUpDate: string) => {
    if (reward.expireOn) {
        const pickUpDateSelected = pickUpDate === 'now'
            ? new Date(new Date().toLocaleDateString())
            : new Date(Date.parse(pickUpDate.replace('UTC', '').trim()));
        pickUpDateSelected.setHours(23, 59, 59, 999); // Move to end of the day

        const rewardExpirationDate = new Date(Date.parse(reward.expireOn));
        rewardExpirationDate.setHours(23, 59, 59, 999); // Move to end of the day

        return pickUpDateSelected > rewardExpirationDate;
    }

    return false;
};

export const updateRewardsDetailsWithUserRewards = (
    rewardsDetailsInfo: RewardsDetails[],
    userRewardsEntity: RewardsEntity[],
) => {
     const rewardsMap = new Map(
        userRewardsEntity.map((r) => [r.code, r.expirationDate]),
    );

    return rewardsDetailsInfo.reduce<RewardsDetails[]>((acc, userReward) => {
        const expirationDate = rewardsMap.get(userReward?.rewardId?.toString());

            const expireOnValue = expirationDate ?? userReward?.expireOn ?? '';

            acc.push({
                ...userReward,
                expireOn: expireOnValue,
            });
        return acc;
    }, []);
};

export default getSortedRewardsDetails;
